module.exports = __webpack_public_path__ + "static/media/shopify5.7659f80f.png";